import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=631b1a3a&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=631b1a3a&lang=scss&scoped=true&"
import style1 from "./SideBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b1a3a",
  null
  
)

export default component.exports